import {getJson, Response} from "./request.ts";

export enum CallMeState {
    InboundOpen,
    OutboundOpen,
    InboundAndOutboundClosed
}

export interface ContactDetails {
    call_center_inbound_open: boolean,
    call_center_outbound_open: boolean,
    phone_no_primary: string,
    phone_no_secondary: string
}

interface ContactDetailsResponse extends Response {
    response: ContactDetails
}

const calculateCallMeState = (details: ContactDetails) => {
    if (details.call_center_inbound_open) {
        return CallMeState.InboundOpen
    }

    if (details.call_center_outbound_open) {
        return CallMeState.OutboundOpen
    }

    return CallMeState.InboundAndOutboundClosed
}

type CallMeNumberVariant = 'a' | 'b'

export const CallMeNumberVariantA: CallMeNumberVariant = 'a'
export const CallMeNumberVariantB: CallMeNumberVariant = 'b'

export const getDetails = async (variant: CallMeNumberVariant) => {
    const details: ContactDetailsResponse = await getJson(`/call-me/details/${variant}`)

    return {
        details: details.response,
        state: calculateCallMeState(details.response)
    }
}
